<template>
    <div class="common-layout">
        <el-container>
            <el-aside :class="{ collapse: isCollapse }">
                <left-menu :isCollapse="isCollapse" />
            </el-aside>
            <el-container>
                <el-header height="60px">
                    <layout-header :isCollapse="isCollapse" />
                </el-header>
                <el-main>
                    <router-view />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script setup>
import leftMenu from './components/leftMenu.vue';
import layoutHeader from './components/layoutHeader.vue';

const isCollapse = ref(false);
</script>

<style lang="less" scoped>
.common-layout {
    // 确保布局容器填满视口
    height: 100vh;
    width: 100vw;
    overflow: hidden;

    // Element Plus 容器样式增强
    .el-container {
        height: 100%;

        // 侧边栏样式
        .el-aside {
            transition: width 0.3s;
            width: 200px;
            -ms-overflow-style: none; /* IE和Edge */
            scrollbar-width: none;
            &::-webkit-scrollbar {
                display: none; /* Chrome, Safari, Opera */
            }

            &.collapse {
                width: fit-content;
            }
            // 菜单滚动条优化
            &:deep(.el-menu) {
                border-right: none;
                height: 100%;
            }

            .leftHeader {
                width: 100%;

                img {
                    width: 100%;
                    height: auto;
                }
            }
        }

        // 头部样式
        .el-header {
            background-color: #ffffff;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
            display: flex;
            align-items: center;
            z-index: 10;
        }

        // 主内容区样式
        .el-main {
            background-color: #f5f7fa;
            padding: 0;
            overflow: auto;

            // 路由视图容器
            & > :deep(div) {
                min-height: calc(100% - 40px);
                // background: white;s
                border-radius: 4px;
                padding: 10px;
                box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
            }
        }
    }
}
</style>
